import React, { Fragment, PureComponent } from 'react'
import { View, Dimensions } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Alert from '../../Atoms/Alert'
import Touchable from '../../Atoms/Touchable'

import SidebarHeader from './SidebarHeader'
import SidebarSectionHeader from './SidebarSectionHeader'
import SidebarOption from './SidebarOption'
import SignOffButton from './SignOffButton'

import NavigationService from '../../../services/navigation'

import theme from '../../../styles/theme'

const Container = styled(View)`
  flex-direction: column;
  background-color: ${theme.colours.black};
  width: ${props => props.sideBarWidth}px;
`

const Divider = styled(View)`
  height: 1px;
  border-bottom-width: 1px;
  border-bottom-color: ${theme.colours.lightgrey};
  margin: ${1.5 * theme.gutterUnit}px 0;
`

const isActive = (activeItem, item) => {
  return activeItem === item.id
}

const screenheight = () => Dimensions.get('window').height

const { statusBarHeight } = theme

export default class Sidebar extends PureComponent {
  state = {
    showSignOffAlert: false
  }

  handleSubmit = () => {
    this.setState({ showSignOffAlert: !this.state.showSignOffAlert })
  }

  onSubmit = () => {
    this.props.onSubmit()
    this.handleSubmit()
  }

  render () {
    const { minimised, sections, activeItem, sideBarFontSize, sidebarWidth, showSignOffButton, lockScreen } = this.props
    const sideBarWidth = minimised ? 100 : sidebarWidth
    const numberOfHeadings = minimised ? 0 : sections.length
    const numberOfItems = numberOfHeadings + sections.reduce((acc, s) => acc + s.items.length, 0)
    const signOffHeight = showSignOffButton ? 100 : 0
    const numberOfDividers = minimised ? 0 : sections.length - 1
    const totalHeightOfDividers = numberOfDividers * 3 * theme.gutterUnit
    const itemHeight = (screenheight() - statusBarHeight - theme.headerHeight - signOffHeight - totalHeightOfDividers) / numberOfItems
    return (
      <Container sideBarWidth={sideBarWidth}>
        <SidebarHeader minimised={minimised} lockScreen={lockScreen} />
        <View style={{ flex: 1 }}>
          {sections.map((section, index) => {
            if (section.items.length === 0) { return null }
            return (
              <Fragment key={section.title}>
                {!minimised && index > 0 && section.items.length && <Divider />}
                {!minimised && <SidebarSectionHeader title={section.title} height={itemHeight} />}
                {section.items.map(item => (
                  <Touchable
                    key={item.id} touchableStyle={{ height: itemHeight }} onPress={() => {
                      NavigationService.navigate(item.id)
                    }}
                  >
                    <SidebarOption
                      active={isActive(activeItem, item)}
                      minimised={minimised}
                      fontSize={sideBarFontSize}
                      {...item}
                    />
                  </Touchable>
                ))}
              </Fragment>
            )
          })}
          {showSignOffButton && <SignOffButton minimised={minimised} onSubmit={this.handleSubmit} />}
          <Alert
            visible={this.state.showSignOffAlert}
            onCancel={() => this.handleSubmit()}
            onConfirm={() => this.onSubmit()}
          >
            <Text size='xxl' overrides={[{ marginBottom: theme.gutterUnit / 2 }]}>Confirm sign off</Text>
            <Text size='s'>Are you sure you want to sign off on your decisions?</Text>
          </Alert>
        </View>
      </Container>
    )
  }
}
